import React from "react";

export function Privacy({ isDarkMode }) {
return (
<div
className={`min-h-[70vh] p-6 lg:px-72 ${
isDarkMode ? "bg-globalBg text-white" : "bg-white text-black"
}`}
>
<h2 className="text-2xl font-extrabold mt-6 text-blue-500 text-center">
PRIVACY POLICY
</h2>

<p className="text-sm text-gray-600 dark:text-gray-300 mt-4 leading-relaxed">
Thank you for using Barelvi 365. Our app is designed to provide accurate
prayer times, Qibla direction, and other essential services. We are
committed to ensuring a seamless experience while respecting your
privacy and data security.
</p>

<section className="mt-6 space-y-6">
<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
1. Location Data
</h5>
<ul className="list-disc pl-6 text-sm text-gray-600 dark:text-gray-400 mt-2 space-y-1">
<li>
We collect your location data to provide accurate prayer times and
other location-based services.
</li>
<li>
Background location access is required for continuous
location-based services.
</li>
<li>
You can disable location services anytime in your device settings.
</li>
</ul>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
2. Motion and Sensor Data
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
We access your device’s motion sensors to determine the Qibla
direction accurately. This data is only used within the app and is
not stored or shared.
</p>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
3. Device and Application Data
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
We collect device-specific information such as your operating
system, app version, and device model to optimize performance. This
helps us identify and fix issues faster.
</p>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
4. Third-Party Authentication
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
We use Google Sign-In for authentication. Google may collect
information according to its own privacy policy.
</p>
</div>

{/* <div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
5. Payments & Subscriptions
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
If your app offers in-app purchases, payments are processed through the App Store's secure payment system. We do not store or process payment information directly.
</p>
</div> */}

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
6. Data Sharing & Security
</h5>
<ul className="list-disc pl-6 text-sm text-gray-600 dark:text-gray-400 mt-2 space-y-1">
<li>
We do not sell or share your personal data with third parties for
marketing purposes.
</li>
<li>
Your data is securely stored and used only for the purposes
mentioned in this policy.
</li>
<li>
We implement security measures to protect against unauthorized
access.
</li>
<li>
User data is stored only as long as necessary and can be deleted
upon request.
</li>
</ul>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
7. Permissions Requested
</h5>
<ul className="list-disc pl-6 text-sm text-gray-600 dark:text-gray-400 mt-2 space-y-1">
<li>
<strong>Location Access:</strong> To determine prayer times and
Qibla direction.
</li>
<li>
<strong>Motion & Sensor Access:</strong> To determine the Qibla
direction.
</li>
<li>
<strong>Google Sign-In:</strong> For authentication purposes.
</li>
<li>
<strong>Local Networking:</strong> To connect with local services
if required.
</li>
</ul>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
8. User Controls
</h5>
<ul className="list-disc pl-6 text-sm text-gray-600 dark:text-gray-400 mt-2 space-y-1">
<li>Disable location services from your device settings.</li>
<li>Revoke Google Sign-In permissions from your Google account.</li>
<li>Uninstall the app if you no longer wish to use it.</li>
<li>Contact us to request data deletion.</li>
</ul>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
9. Updates to This Policy
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
We may update this Privacy Policy from time to time. Any changes
will be reflected in the app and will take effect immediately upon
posting.
</p>
</div>

<div>
<h5 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
10. Contact Us
</h5>
<p className="text-sm text-gray-600 dark:text-gray-400">
If you have any questions or concerns about this Privacy Policy,
please contact us at:
</p>
<p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
📧 Email: support@11solutions 📞 Phone: +91 9902394394
</p>
</div>
</section>
</div>
);
}